module.exports = __webpack_public_path__ + "img/sport.74120b9c.png";